import { render, staticRenderFns } from "./AchiTeam.vue?vue&type=template&id=973299d4&scoped=true&"
import script from "./AchiTeam.vue?vue&type=script&lang=js&"
export * from "./AchiTeam.vue?vue&type=script&lang=js&"
import style0 from "./AchiTeam.vue?vue&type=style&index=0&id=973299d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973299d4",
  null
  
)

export default component.exports